<template>
    <div class="wrapper">
        <side-bar>
            <mobile-menu slot="content"></mobile-menu>
        
            <sidebar-link to="/plants">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Plants</p>
            </sidebar-link>
            <sidebar-link to="/diseases">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Diseases</p>
            </sidebar-link>
            <sidebar-link to="/articles">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Articles</p>
            </sidebar-link>
           
           <sidebar-link to="/suggestions">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Suggestions</p>
            </sidebar-link>
           
            <span class="delimiter"></span>
            
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <dashboard-content @click="toggleSidebar">

            </dashboard-content>

            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss">
    .delimiter {
        display: block;
        width: 100%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
</style>
<script>
    import TopNavbar from './TopNavbar.vue'
    import ContentFooter from './ContentFooter.vue'
    import DashboardContent from './Content.vue'
    import MobileMenu from './MobileMenu.vue'

    export default {
        components: {
            TopNavbar,
            ContentFooter,
            DashboardContent,
            MobileMenu
        },
        methods: {
            toggleSidebar () {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false)
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue